import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../contexts";
import { PageHeader, EmptyState } from "../components/ui-bits";

export default function OrdersPage() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    if (user) api.get("/orders/mine").then((r) => setOrders(r.data));
  }, [user]);

  if (!user) {
    return (
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 py-16">
        <p className="font-mono-label text-neutral-500 mb-4">Sign in to see your orders.</p>
        <Link to="/login" className="btn-primary">Sign In</Link>
      </div>
    );
  }

  return (
    <div className="pb-32">
      <PageHeader kicker="HISTORY" title="MY ORDERS" />
      <div className="divider-tape" />
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 py-10">
        {orders.length === 0 ? (
          <EmptyState>No orders yet. <Link to="/merch" className="underline">Shop the drop.</Link></EmptyState>
        ) : (
          <div className="space-y-4" data-testid="orders-list">
            {orders.map((o) => (
              <div key={o.id} className="border border-neutral-800 p-5" data-testid={`order-${o.id}`}>
                <div className="flex flex-wrap justify-between items-center gap-4 mb-3">
                  <div>
                    <div className="font-mono-label text-[10px] text-neutral-500">ORDER #{o.id.slice(0, 8).toUpperCase()}</div>
                    <div className="font-mono-label text-[10px] text-neutral-500">{new Date(o.created_at).toLocaleString()}</div>
                  </div>
                  <span className={`chip ${o.status === "paid" ? "chip-accent" : ""}`} data-testid={`order-status-${o.id}`}>{o.status.toUpperCase()}</span>
                </div>
                <div className="grid sm:grid-cols-2 gap-2 mb-3">
                  {o.items.map((it, i) => (
                    <div key={`${o.id}-${it.product_id || it.id || i}`} className="flex justify-between text-sm text-neutral-300">
                      <span className="truncate pr-3">{it.title} × {it.quantity}{it.size && ` (${it.size})`}</span>
                      <span>${(it.price * it.quantity).toFixed(2)}</span>
                    </div>
                  ))}
                </div>
                <div className="divider-tape mb-3" />
                <div className="flex justify-between font-headline uppercase">
                  <span>Total</span>
                  <span>${o.total.toFixed(2)}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
